import { render, staticRenderFns } from "./RiskList.vue?vue&type=template&id=1b756fb5&scoped=true&"
import script from "./RiskList.vue?vue&type=script&lang=js&"
export * from "./RiskList.vue?vue&type=script&lang=js&"
import style0 from "./RiskList.vue?vue&type=style&index=0&id=1b756fb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b756fb5",
  null
  
)

export default component.exports